import React, { useEffect, useState } from "react";
import Header from "./Header";
import { useParams, Link } from "react-router-dom";

const OutputComp = () => {
  const { category, courseName } = useParams();
  const [sources, setSources] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/course/coursedetails`);
        const data = await response.json();
        setSources(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Normalize URL strings
  const normalizedCategory = decodeURIComponent(category || "");
  const normalizedCourse = decodeURIComponent(courseName || "");

  // Filter by category + course
  const filteredData = sources.filter(
    (item) =>
      item.category_name === normalizedCategory &&
      item.course_name === normalizedCourse
  );

  // Unique subjects
  const uniqueSubjects = [...new Set(filteredData.map((each) => each.subject_name))];

  return (
    <div>
      <Header />

      {/* Title Section */}
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2 style={{ color: "#2873b9ff" }}>
          {normalizedCategory} → {normalizedCourse}
        </h2>
      </div>

      {/* Subject List */}
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        {uniqueSubjects.length > 0 ? (
          uniqueSubjects.map((subject, index) => (
            <Link
              key={index}
              to={`/${encodeURIComponent(normalizedCategory)}/${encodeURIComponent(
                normalizedCourse
              )}/${encodeURIComponent(subject)}`}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  border: "1px solid #2873b9ff",
                  padding: "20px",
                  margin: "10px 0",
                  borderRadius: "10px",
                  backgroundColor: "#f9f9ff",
                  color: "black",
                }}
              >
                <p>
                  <strong>Subject:</strong> {subject}
                </p>
              </div>
            </Link>
          ))
        ) : (
          <p
            style={{
              textAlign: "center",
              color: "gray",
              marginTop: "40px",
              fontSize: "18px",
            }}
          >
            No subjects found for this course.
          </p>
        )}
      </div>
    </div>
  );
};

export default OutputComp;
